<div class="basin-pb-2 basin-width-100">
    <div class="basin-display-flex basin-align-items-center basin-pb-2">
        Your simulation is now running in the background. You'll receive an email notification once the results are ready for download.
    </div>
</div>

<div class="p-d-flex p-flex-row p-jc-end">
    <button pButton (click)="onAccept(Decision.Stay)" label="Go Back" class="p-button-text basin-mr-6"></button>
    <button pButton (click)="onAccept(Decision.Leave)" class="p-button-text submit-button" label="Sign Out"></button>
</div>
